// @ts-nocheck
export const headers = {
  'Content-Type': 'multipart/form-data',
};

export default function getFormData(payload) {
  const formdata = new FormData();
  Object.keys(payload).forEach((key) => {
    if (payload[key] !== null) {
      if (typeof payload[key] === 'object') {
        payload[key] instanceof File
          ? formdata.append(key, payload[key])
          : formdata.append(key, JSON.stringify(payload[key]));
      } else {
        formdata.append(key, payload[key]);
      }
    }
  });
  return formdata;
}
